// extracted by css-extract-rspack-plugin
export default {"root":"ST7BT","circle":"bbREq"};